// extracted by mini-css-extract-plugin
export default {"ribbonBanner":"RibbonBanner_ribbonBanner__30wsl"};